import PaymentsPage from './views/payments-page.c';
export default PaymentsPage;
